import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterLoadingComponent = ({
  height
}) => /*#__PURE__*/_jsx(UIFlex, {
  style: {
    height: height || 90
  }
});
export default FilterLoadingComponent;